import React, { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import Icon, { IconIds } from 'src/common/components/IconDS22';

import styles from './Notification.module.scss';

type AnyString = string & {};
export type Translation = 'common' | 'search-page' | AnyString;

export type TranslationOption = Record<string, string | number>;

type BaseProps = {
  translation?: Translation;
  messageKeyCount?: number;
  iconId?: IconIds;
  translationOptions?: TranslationOption;
  actionKey?: string;
  action?: () => void;
};

type HeadingRequired = { headingKey: string; messageKey?: string };
type MessageRequired = { headingKey?: string; messageKey: string };

export type NotificationProps = (HeadingRequired | MessageRequired) & BaseProps;

/**
 * A notification must have at least a headingKey or a messageKey.
 * For bold h6 text, use titleKey; for regular p text, use messageKey.
 */
const Notification: FC<NotificationProps> = ({
  translation = 'common',
  headingKey,
  messageKey,
  messageKeyCount,
  actionKey,
  action,
  iconId,
  translationOptions,
}) => {
  const [t] = useTranslation(translation);
  return (
    <div className={styles.root}>
      {(iconId || headingKey) && (
        <div className={styles.row}>
          {iconId && (
            <Icon
              id={iconId}
              size="m"
            />
          )}
          {headingKey && (
            <h6 className={styles.title}>
              {translationOptions ? t(headingKey, translationOptions) : t(headingKey) }
            </h6>
          )}
        </div>
      )}
      {messageKey && (
        <p className={styles.message}>
          <Trans
            t={t}
            i18nKey={messageKey}
            count={messageKeyCount}
            tOptions={translationOptions}
            components={[
              <button
                type="button"
                onClick={action}
                className={styles.action}
                {...(actionKey
                  ? { 'aria-label': t(actionKey) }
                  : {})}
              />,
            ]}
          />
        </p>
      )}
    </div>
  );
};

export default Notification;
